import React from "react"
import {
  StyledPanelBodySection,
  StyledPanelBoilerplate,
} from "gatsby-interface"
import { CmsAuthorizationForm } from "@modules/cms/authorization/components/CmsAuthorizationForm"
import { AuthorizedForm } from "@modules/cms/authorization/components/AuthorizedForm"
import { AuthorizingWindow } from "@modules/cms/authorization/components/AuthorizingWindow"
import { OnboardingSiteType } from "@modules/onboarding/shared/constants"
import { VerificationStatus } from "@modules/cms/shared/utils/constants"
import { useCmsAuthStatus } from "../hooks/useCmsAuthStatus"
import { cmsIntegration as cmsIntegrationText } from "@modules/locales/default.js"
import { interpolateMessage } from "@modules/locales"

export function CmsAuthorizationModal({
  isOpen,
  siteId,
  closeModal,
  orgSiteName,
  isConnected,
  name: cmsVendor,
  formattedName,
  type = OnboardingSiteType.Create,
  refetch,
}) {
  const [
    modalStatus,
    handleAuthorized,
    handleAuthorizing,
    requestAuthorization,
  ] = useCmsAuthStatus(
    cmsVendor,
    siteId,
    isConnected
      ? VerificationStatus.Authorized
      : VerificationStatus.Authorization
  )

  return (
    <StyledPanelBoilerplate
      isOpen={isOpen}
      aria-label={interpolateMessage(
        cmsIntegrationText.headers.connectIntegrationLong,
        { vendorName: formattedName }
      )}
      header={interpolateMessage(
        cmsIntegrationText.headers.connectIntegration,
        { vendorName: formattedName }
      )}
      onClose={closeModal}
    >
      {modalStatus === VerificationStatus.Authorization && (
        <StyledPanelBodySection>
          <CmsAuthorizationForm
            siteId={siteId}
            siteName={orgSiteName}
            cmsVendor={cmsVendor}
            cmsVendorName={formattedName}
            isProvisioning={type === OnboardingSiteType.Provision}
            onCancel={closeModal}
            onAuthorize={handleAuthorizing}
            onComplete={handleAuthorized}
          />
        </StyledPanelBodySection>
      )}

      {modalStatus === VerificationStatus.Authorizing && (
        <StyledPanelBodySection>
          <AuthorizingWindow
            type={type}
            siteId={siteId}
            cmsVendor={cmsVendor}
            formattedName={formattedName}
            onAuthorizing={handleAuthorizing}
          />
        </StyledPanelBodySection>
      )}

      {modalStatus === VerificationStatus.Authorized && (
        <AuthorizedForm
          type={type}
          siteId={siteId}
          cmsVendor={cmsVendor}
          orgSiteName={orgSiteName}
          refetch={refetch}
          onFinish={closeModal}
          onCancel={closeModal}
          onFetchError={requestAuthorization}
        />
      )}
    </StyledPanelBoilerplate>
  )
}
